import React, { useEffect, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
// import { NavLink } from 'react-router-dom';
import StatsCard from './Home/StatsCard';
import RefSetsCard from './Home/RefSetsCard';
import LinkIcon from '@material-ui/icons/Link';
import { GlobalContext } from './contexts/GlobalContext';
import './HomePage.css';

function HomePage() {
	const globals = useContext(GlobalContext)

	useEffect(() => {
		globals.initAnalytics();
		globals.logPageAnalytics();
	}, [globals])

	return (
		<div className="home">
			<div className="home__body">
				<div className="home__intro">
					<p className="home__introPreamble">
						The referenced terminology server has the following content within
						it. The server being used is:
						</p>

					<div className="home__introServer">
						<LinkIcon className="home__introServerIcon" />

						<div className="home__introServerUrl">{globals.server}</div>
					</div>
				</div>
				<Grid container className="home__grid" spacing={2}>
					<Grid item xs={12}>
						<Grid container justify="center" spacing={3}>
							{['CS', 'VS', 'CM', 'NS'].map((value) => (
								<Grid key={value} item>
									<StatsCard cat={value} />
								</Grid>
							))}
							{/* <NavLink to="/RefSets" exact> */}
							<Grid key="refsets" item>
								<RefSetsCard />
							</Grid>
							{/* </NavLink> */}
						</Grid>
					</Grid>
				</Grid>
			</div>{' '}
		</div>
	);

}

export default HomePage;
